module.exports = __webpack_public_path__ + "img/img25.37819aff.png";